import { useEffect, useState } from "react"
import axios from "axios"
import AppLayout from "@/components/app/AppLayout"
import { PilotBanner } from "@/components/app/PilotBanner"
import { Button } from "@/components/ui/button"
import { Switch } from "@/components/ui/switch"
import { API_BASE } from "@/config/api"
import { useEntitlements } from "@/hooks/use-entitlements"
import { toast } from "sonner"

const API = API_BASE

const ADDON_LABELS = {
  ehr_connector: "EHR / FHIR",
  adt_and_beds: "ADT & Paturi",
  marketing_suite: "Marketing Suite",
}

export default function IntegrationsApp() {
  const { plan, addons, hasFeature } = useEntitlements()
  const [catalog, setCatalog] = useState([])
  const [localAddons, setLocalAddons] = useState(addons)

  useEffect(() => {
    axios.get(`${API}/integrations/connections`).then((r) => setCatalog(r.data)).catch(() => {})
  }, [])

  useEffect(() => { setLocalAddons(addons) }, [addons])

  const toggleAddon = (id) => {
    setLocalAddons((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]))
  }

  const saveAddons = async () => {
    try {
      const addon_ids = localAddons.filter((id) => id !== "predictive_ai" && ADDON_LABELS[id])
      await axios.patch(`${API}/subscription/addons`, { addon_ids })
      toast.success("Add-on-uri actualizate")
    } catch (e) {
      const detail = e.response?.data?.detail
      if (detail?.code === "checkout_required") {
        toast.message(detail.message || "Necesită checkout Stripe Clinic")
      } else if (detail?.code === "upgrade_required") {
        toast.error("Necesită plan Clinic")
      } else {
        toast.error(typeof detail === "string" ? detail : "Eșuat")
      }
    }
  }

  const syncEhr = async () => {
    try {
      const { data } = await axios.post(`${API}/integrations/ehr/sync-demo`)
      toast.message(data.message || "Simulare timestamp (fără FHIR)")
      const r = await axios.get(`${API}/integrations/connections`)
      setCatalog(r.data)
    } catch (e) {
      const detail = e.response?.data?.detail
      toast.error(typeof detail === "string" ? detail : "Sincronizare EHR indisponibilă")
    }
  }

  return (
    <AppLayout title="Integrări">
      <div className="max-w-2xl space-y-8">
        {plan === "clinic" && (
          <section className="rounded-xl border border-border p-6 bg-card">
            <h3 className="text-sm font-medium mb-4">Add-on-uri (plan Clinic)</h3>
            <ul className="space-y-3">
              {Object.entries(ADDON_LABELS).map(([id, label]) => (
                <li key={id} className="flex items-center justify-between text-sm">
                  <span>{label}</span>
                  <Switch checked={localAddons.includes(id)} onCheckedChange={() => toggleAddon(id)} />
                </li>
              ))}
            </ul>
            <Button className="rounded-full mt-4" onClick={saveAddons}>Salvează add-on-uri</Button>
          </section>
        )}
        <section className="rounded-xl border border-border p-6 bg-card">
          <h3 className="text-sm font-medium mb-4">Conexiuni</h3>
          <ul className="space-y-3 text-sm">
            {catalog.map((item, i) => (
              <li key={i} className="flex justify-between items-center">
                <span>{item.catalog?.label}</span>
                <span className="text-xs text-muted-foreground capitalize">
                  {item.connection?.status || "disconnected"}
                </span>
              </li>
            ))}
          </ul>
          {hasFeature("ehr_sync") && (
            <div className="mt-4 space-y-3">
              <PilotBanner>
                Doar pentru dezvoltare: actualizează un timestamp „pilot” — nu importă date FHIR. Indisponibil în producție.
              </PilotBanner>
              <Button variant="outline" className="rounded-full" onClick={syncEhr}>
                Simulare timestamp (fără FHIR)
              </Button>
            </div>
          )}
        </section>
      </div>
    </AppLayout>
  )
}
